import * as React from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useRoute } from 'wouter';
import DynamicTable from '../DynamicTable';
import {
  TABLE_IMPORT_TEMPLATE,
  TABLE_REFUELINGS_IMPORT,
  TABLE_REFUELINGS_IMPORT_RECORDS,
} from '../../Services/TableService';
import TabComponent from '../TabComponent';
import { tabsByPermission } from '.';
import PermissionsService, { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { URL_EXPENSE_IMPORT } from '../../router/constants';
import useUrlQueryParams from '../../hooks/useUrlQueryParams';
import Form from './Form';
import { IValidationRule } from '../../Services/FormikValidatorService';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import PageHeader from '../PageHeader';

export interface IImportsInput {
  indexId: string;
  type: string;
  subtype?: string;
  title: string;
  placeholder: string;
  value?: string | undefined;
  values?: {
    item: string;
    value: string;
  };
  firstDisabled: boolean;
  multiple: boolean;
  disabled: boolean;
  readonly: boolean;
  sendOnChange: boolean;
  rules: IValidationRule[];
  section: any;
  inputGroup: any;
}

export default function ImportRecord(): JSX.Element {
  const tabs = React.useState(
    tabsByPermission(
      [TABLE_REFUELINGS_IMPORT_RECORDS, TABLE_REFUELINGS_IMPORT, TABLE_IMPORT_TEMPLATE],
      TABLE_REFUELINGS_IMPORT
    )
  )[0];
  const othersButtons = React.useState<{
    [key: string]: { open: boolean | string[]; handle?: boolean | string[] | undefined };
  }>({
    [TABLE_REFUELINGS_IMPORT]: {
      open: false,
      handle: ['close', 'save'],
    },
  })[0];

  const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
  const [callTable, setCallTable] = React.useState<boolean>(false);
  const [customerId, setCustomerId] = React.useState<number | null>(null);
  const [data, setData] = React.useState<any[]>([]);
  const [pathname, navigate] = useLocation();
  const query = useUrlQueryParams();
  const [, params] = useRoute(`${URL_EXPENSE_IMPORT}/edit/:id`);
  const { setDocumentTitle } = useDocumentTitle();
  const { formatMessage: f } = useIntl();

  const handleClose = React.useCallback(() => {
    navigate(`${URL_EXPENSE_IMPORT}/expense/import`);
    setIsModalOpened(false);
    setData([]);
    setCustomerId(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateTable = () => {
    setCallTable(true);
  };

  const handleModal = React.useCallback((formData: any, _idValue: number, customer: number) => {
    if (formData) {
      setIsModalOpened(true);
      setData(formData);
      setCustomerId(customer);
      setCallTable(false);
    }
  }, []);

  React.useEffect(() => {
    if (pathname === `${URL_EXPENSE_IMPORT}/expense/import`) {
      setIsModalOpened(false);
      setCustomerId(null);
      setData([]);
      // } else if (pathname === `${URL_FUEL_CARDS}/add`) {
      //   setIsModalOpened(true);
      const documentTitle = `${f({ id: 'tab.expense/import' })} - ${f({
        id: 'menu.expenseImports',
      })}`;
      setDocumentTitle(documentTitle);
    } else if (params) {
      const customerIdUrl = query.get('customerId');
      if (customerId) {
        setCustomerId(Number(customerIdUrl));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, params, pathname, query]);

  React.useEffect(() => {
    if (data.length === 0 && params) {
      const customerIdUrl = query.get('customerId');
      if (customerIdUrl) {
        setCustomerId(Number(customerIdUrl));
      }
      setCallTable(false);
    }
  }, [data, data.length, query, pathname, params]);
  return (
    <div>
      <PageHeader
        title={`${f({ id: 'menu.expenseImports' })}`}
        onlineHelpTopic="import-refuelings"
      />
      <div className="col-12">
        <TabComponent tabs={tabs}>
          <DynamicTable
            name={TABLE_REFUELINGS_IMPORT}
            mustClosed={true}
            buttons={othersButtons[TABLE_REFUELINGS_IMPORT]}
            dragClassname="drag"
            handleForm={handleModal}
            updateTable={callTable}
            routerParams={params}
          />
        </TabComponent>
      </div>
      {isModalOpened && data && data.length > 0 && params && (
        <div>
          {PermissionsService.hasAccess(PERMISSION_IMPORTED_RECORD, ['update'], customerId) && (
            <Form
              id={Number(params.id)}
              customerId={customerId}
              data={data}
              updateTable={updateTable}
              handleClose={handleClose}
            />
          )}
        </div>
      )}
    </div>
  );
}
